<div class="collection-header-line">
  <div class="collection-edit-sync-line">
    <div *ngIf="collection?.modifiedTime">
      <u-icon [model]="{ type: 'font', value: 'icon-clock' }" [styles]="{ fontSize: '12px' }"></u-icon>
      <div
        class="text"
        [pTooltip]="!minimizeHeaderText ? modifiedTimeActual : lastSyncAndUpdateTime"
        tooltipPosition="bottom"
        tooltipStyleClass="u-tooltip"
      >
        {{ !minimizeHeaderText ? lastUpdateMessage : lastUpdateShortMessage }}
      </div>
    </div>
    <div *ngIf="lastSyncText && !minimizeHeaderText">
      <u-icon [model]="{ type: 'font', value: 'icon-sync' }" [styles]="{ fontSize: '12px' }"></u-icon>
      <div class="text" [pTooltip]="lastSyncActual" tooltipPosition="bottom" tooltipStyleClass="u-tooltip">
        {{ lastSyncMessage }}
      </div>
    </div>
  </div>
  <div class="header-btns-container">
    <avatar-list
      class="avatar-list"
      *ngIf="collection?.isShared && avatarsList?.length > 0"
      [model]="avatarsList"
      tooltipHeader="SHARED WITH"
      [spreadAvatarsCount]="3"
      [tooltipLimit]="99"
      [sizeAvatarTooltip]="'16px'"
    ></avatar-list>

    <u-button
      *ngIf="collection?.isShared && canEdit"
      class="no-border-button share-button"
      label="Share"
      type="secondary"
      elementSize="very-small"
      (onClick)="onShareClick()"
    ></u-button>

    <u-button
      *ngIf="!collection?.isShared && canEdit"
      class="no-border-button share-button"
      label="Share"
      type="secondary"
      [fontIcon]="'lock'"
      elementSize="very-small"
      (onClick)="onShareClick()"
      (mouseover)="op.show($event, actualTarget)"
      (mouseleave)="onHidePanel(op)"
    >
      <p-overlayPanel #op [showTransitionOptions]="'0.2s'" [hideTransitionOptions]="'0ms'">
        <div class="share-tooltip">
          <div class="share-tooltip-title tooltip-main-color">Only {{ username ?? 'Unknown' }} (you) have access</div>
          <div class="share-tooltip-subtitle tooltip-secondary-color">Click to share with your team</div>
        </div>
      </p-overlayPanel>
    </u-button>

    <u-button
      #actions
      *ngIf="collection?.kind === 'Wiki'"
      class="header-icon icon-button-clean"
      elementSize="small"
      [fontIcon]="'verify'"
      type="secondary"
      [styles]="{ fontSize: '12px' }"
      debounceClick
      (debounceClick)="onVerificationClick()"
      tooltipPosition="bottom"
      [pTooltip]="'Verification'"
      tooltipStyleClass="u-tooltip"
    ></u-button>

    <u-button
      #actions
      *ngIf="canEditPin || (!canEditPin && collection?.pinBy)"
      class="header-icon icon-button-clean"
      [ngClass]="{ 'pin-button': collection?.pinBy }"
      elementSize="small"
      [fontIcon]="collection?.pinBy ? 'windows-full-pin' : 'windows-pin'"
      type="secondary"
      [styles]="{ fontSize: '12px' }"
      debounceClick
      (debounceClick)="onPinClick()"
      [disabled]="!canEditPin"
      tooltipPosition="bottom"
      [pTooltip]="canEditPin ? (!collection?.pinBy?.length ? 'Pin' : 'Manage pins') : ''"
      tooltipStyleClass="u-tooltip"
    ></u-button>

    <u-button
      *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG"
      #actions
      class="header-icon icon-button-clean"
      elementSize="small"
      [fontIcon]="isFavorite ? 'star-solid' : 'star'"
      type="secondary"
      [styles]="{ fontSize: '12px' }"
      debounceClick
      (debounceClick)="onFavoriteClick()"
      tooltipPosition="bottom"
      [pTooltip]="favoriteTooltipText"
      tooltipStyleClass="u-tooltip"
    ></u-button>
    <square-button
      [active]="contextMenuActive"
      (click)="$event.stopPropagation(); openContextMenu($event)"
      (auxclick)="$event.stopPropagation(); openContextMenu($event)"
      (contextmenu)="$event.stopPropagation(); openContextMenu($event)"
      #actions
      >•••</square-button
    >
  </div>
</div>
